import * as actions from './getAddressesActions';
import { capitalize } from '../../../lib/helpers';

const getAddressesReducers = {
  [actions.USER_GET_ADDRESSES_SUCCESS_RECEIVED]: (state, { payload }) => {
    state.addresses = payload.reduce((acc, curr) => {
      acc[actions.ADDRESS_TYPES[curr.addressType]] = {
        ...curr,
        streetAddress: capitalize(curr.streetAddress),
        city: capitalize(curr.city),
      };
      return acc;
    }, {});

    return state;
  },
};

export default getAddressesReducers;
